import ZlbConfirm from '@/components/ZlbConfirm';
import { message } from 'doraemon';
import {
  reqPositionManagerList,
  reqPositionManagerCreate,
  reqPositionManagerUpdate,
  reqPositionManagerUpdateStatus,
  reqPositionManagerRename,
  reqPositionManagerDelete,
  reqPositionDetail,
  reqPositionManagerPersonals,
  reqPagingPersonals,
  reqRoleTree,
  reqOperatorListByPositionWithPagination,
  reqTreeDepartPersonnels,
  reqInstitutionPersonnels,
  reqOptRole,
} from '../services';

let allKeys = [];
let expandedKeys = [];
/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

// 渲染岗位树
const generateList = (data) => {
  for (let i = 0; i < data.length; i ++) {
    const item = data[i];
    if (!allKeys.includes(`${item.key}`) && item.type === '4') {
      allKeys.push(`${item.key}`);
    }
    if (item.children) {
      generateList(item.children);
      !expandedKeys.includes(`${item.key}`) && expandedKeys.push(`${item.key}`);
    }
  }
};

export default {
  namespace: 'authority',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
    },
    // 机构岗位树
    privilegePositionList: [],
    positionDetail: {},
    // 岗位关联操作人
    operatorList: {},
    list: {},
    roleTree: [],
    roleExpandedKeys: [],
    roleAllKeys: [],
  },
  effects: {
    * fetchPositionManagerList ({ payload }, { call, put }) {
      const res = yield call(reqPositionManagerList, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      const { data } = res.result;
      yield put({
        type: 'update',
        payload: {
          privilegePositionList: data || [],
        },
      });
    },
    // 获取岗位详情
    * fetchPositionDetail ({ payload }, { call, put }) {
      const res = yield call(reqPositionDetail, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      yield put({
        type: 'update',
        payload: {
          positionDetail: res.result,
        },
      });

      return res.result;
    },
    // 获取岗位对应人员列表
    * fetchOperatorList ({ payload }, { call, put }) {
      const res = yield call(reqOperatorListByPositionWithPagination, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      yield put({
        type: 'update',
        payload: {
          operatorList: res.result,
          tableQueryParams: {
            pageNo: payload.pageNo,
            pageSize: payload.pageSize,
          },
        },
      });

      return res.result;
    },
    * fetchRoleTree ({ payload }, { call, put }) {
      const { result: res, success, message: msg } = yield call(reqRoleTree, payload);
      if (!success) return message.error(msg);
      // 生成展开节点所需的key
      allKeys = [];
      expandedKeys = [];
      generateList(res || []);

      yield put({
        type: 'update',
        payload: {
          roleTree: res || [],
          roleExpandedKeys: expandedKeys,
          roleAllKeys: allKeys,
        },
      });

      return res;
    },
    * positionManagerCreate ({ payload }, { call }) {
      const res = yield call(reqPositionManagerCreate, payload);
      responseErrorHandle(res);
      return res;
    },
    * positionManagerUpdateStatus ({ payload }, { call }) {
      const res = yield call(reqPositionManagerUpdateStatus, payload);
      responseErrorHandle(res);
      return res;
    },
    * positionManagerDelete ({ payload }, { call }) {
      const res = yield call(reqPositionManagerDelete, payload);
      responseErrorHandle(res);
      return res;
    },
    * positionManagerRename ({ payload }, { call }) {
      const res = yield call(reqPositionManagerRename, payload);
      responseErrorHandle(res);
      return res;
    },
    * positionManagerUpdate ({ payload }, { call }) {
      const res = yield call(reqPositionManagerUpdate, payload);
      responseErrorHandle(res);
      return res;
    },
    //
    * fetchTreeDepartPersonnels ({ payload }, { call }) {
      const res = yield call(reqTreeDepartPersonnels, payload);
      responseErrorHandle(res);
      return res;
    },
    // 机构下所有人员
    * fetchInstitutionPersonnels ({ payload }, { call }) {
      const res = yield call(reqInstitutionPersonnels, payload);
      responseErrorHandle(res);
      return res;
    },
    * optRole ({ payload }, { call }) {
      const res = yield call(reqOptRole, payload);
      responseErrorHandle(res);
      return res;
    },
    * fetchPositionManagerPersonals ({ payload }, { call }) {
      const res = yield call(reqPositionManagerPersonals, payload);
      responseErrorHandle(res);
      return res;
    },

    * fetchPagingPersonnel ({ payload }, { call }) {
      const res = yield call(reqPagingPersonals, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
